import React from "react";
import ScheduleItem from "../WeekView/LiveEvent";
import "./style.scss";

const DayView = ({ data, changeView }) => {
  const items = data;
  if (items.length === 0) {
    return <div className="no-events">No Live Events for today</div>;
  }
  return (
    <div className="DayView">
      {items.map((item, i) => {
        return <ScheduleItem event={item} key={i} />;
      })}
    </div>
  );
};

export default DayView;